import { REQUEST_UNSUBSCRIBE, SUCCESS_UNSUBSCRIBE, FAILURE_UNSUBSCRIBE } from './constants';
import { CALL_API } from '../../middlewares/api';

export function sendUnsubscribeRequest(email) {
    return {
        [CALL_API]: {
            endpoint: '/user/unsubscribe',
            body: { email: email },
            types: [REQUEST_UNSUBSCRIBE, SUCCESS_UNSUBSCRIBE, FAILURE_UNSUBSCRIBE]
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/unsubscribe/actions.js